import { NotificationType } from "../../constants/Enums";

// Lets non-React code (e.g. the FCM push handler and the native bridge) trigger
// the in-app toast that normally lives in NotificationContext. The provider
// registers its trigger on mount; callers use showToast().

type ToastTrigger = (message: string, type: NotificationType) => void;

let trigger: ToastTrigger | null = null;

export function registerToastTrigger(fn: ToastTrigger | null): void {
  trigger = fn;
}

export function showToast(message: string, type: NotificationType): void {
  trigger?.(message, type);
}
